import { onMounted, onUnmounted } from 'vue'
import { EventBus } from '@/services/event-bus'
import { useCacheStore } from '@/stores/CacheStore'
import { useRoute, useRouter } from 'vue-router'

export function useAppEventHandlers() {
  const cacheStore = useCacheStore()
  const route = useRoute()
  const router = useRouter()

  onMounted(() => {
    EventBus.subscribe('httpError', handleHttpError)
  })

  onUnmounted(() => {
    EventBus.unsubscribe('httpError', handleHttpError)
  })

  const handleHttpError = (status: number) => {
    switch (status) {
      case 0: // this commonly happens when there is no internet connection
      case 503:
        EventBus.dispatch('ServiceUnavailable')
        return
      case 401: // Unauthorized (this website features no user login)
        break
      case 403: // Forbidden, this means that user tried to access a page ore functionality which is not allowed
        // navigate to the main page
        router.push({ name: 'home' })
        return
      default:
    }
  }
}